import { useMutation } from "react-query";
import { updateEmployeeAdOverrideGroup } from "../api";

export const useUpdateEmployeeAdOverrideGroup = () => {
  return useMutation(updateEmployeeAdOverrideGroup);
};
